import * as React from 'react';
import { FC } from 'react';

import { MainHeroContainer } from 'components/features/components/main-hero/main-hero-container';
import LoadingAnimation from 'components/loading-animation';
import LoadingContainer from 'components/loading-animation/loading-container';

import { ICateringPageViewProps } from './types';

export const CateringPageView: FC<ICateringPageViewProps> = ({
  isLoading,
  featureCateringPage,
}) => {
  if (isLoading) {
    return (
      <LoadingContainer>
        <LoadingAnimation />
      </LoadingContainer>
    );
  }
  return (
    <>
      {featureCateringPage?.components?.map(item => {
        switch (item?.__typename) {
          case 'MainHero': {
            return (
              <div key={`CateringPage_MainHero_${item._id}`}>
                <MainHeroContainer item={item} />
              </div>
            );
          }
          default:
            return null;
        }
      })}
    </>
  );
};
